import React from 'react';
import Placeholder from 'react-bootstrap/Placeholder';
import Table from 'react-bootstrap/Table';

function TableLoader() {
  // Function to generate table rows with placeholders
  const generateTableRows = (rowCount, columnCount) => {
    const rows = [];
    for (let i = 0; i < rowCount; i++) {
      const columns = [];
      for (let j = 0; j < columnCount; j++) {
        columns.push(
          <td key={j}>
            <Placeholder as="div" animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
          </td>
        );
      }
      rows.push(<tr key={i}>{columns}</tr>);
    }
    return rows;
  };

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <Placeholder as="th" xs={2} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="th" xs={4} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="th" xs={3} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="th" xs={3} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
        </tr>
      </thead>
      <tbody>
        {/* Generate 5 rows with 4 columns each */}
        {generateTableRows(5, 4)}
      </tbody>
    </Table>
  );
}

export default TableLoader;
